export default "__VITE_ASSET__BAMvC3t___"